<template>
  <div class="wrapper-x-40">
    <AdminStickyHeader>
      <template #title>
        {{ element ? $t('main.title_edit_element')+":" : $t('main.title_add_element')+":" }}
        {{ this.element_group && this.element_group.data.attributes.name }}
      </template>
      <template #actions>
        <Loading
          v-if="loadingSaveData"
          class="mb-2"
        />
        <div class="form-group flex flex-wrap gap-3">

          <button
            @click="saveClose"
            type="button"
            class="btn btn-small btn-default"
          >
            {{ $t('main.button_save_close') }}
          </button>

          <button
            @click="save"
            type="button"
            class="btn btn-small btn-green"
          >
            {{ $t('main.button_save') }}
          </button>

          <button
            @click="saveCreate"
            type="button"
            class="btn btn-small btn-default"
          >
            <i
              class="fa fa-plus"
              aria-hidden="true"
            ></i>
            {{ $t('main.button_save_create') }}
          </button>

          <router-link
            class="btn btn-small btn-red"
            :to="{
              name: 'engravings',
              params: {
                slug:
                  this.element_group && this.element_group.data.attributes.slug,
              },
              query: $route.query
            }"
          >{{ $t('main.button_cancel') }}</router-link>

          <button
            @click="saveCopy"
            type="button"
            class="btn btn-small btn-blue"
          >
            {{ $t('main.button_save_copy') }}
          </button>

        </div>
      </template>
    </AdminStickyHeader>
    <div class="form">
      <div class="flex items-start">
        <div class="w-1/3">
          <div class="form-group">
            <label
              for="name"
              class="font-bold"
            >{{ $t('main.label_name') }} *:</label>
            <div class="flex items-center">
              <input
                id="name"
                type="text"
                v-model="form.name"
              />
            </div>
            <ValidationErrors :errors="errorsFor('name')" />
          </div>

          <div class="form-group">
            <label
              for="article"
              class="font-bold"
            >{{ $t('main.label_articul') }}</label>
            <div class="flex items-center">
              <input
                id="article"
                type="text"
                v-model="form.article"
              />
            </div>
            <ValidationErrors :errors="errorsFor('article')" />
          </div>

          <div class="form-group">
            <label
              for="type_id"
              class="font-bold"
            >{{ $t('main.select_type') }} *:</label>
            <div class="flex items-center">
              <select
                id="type_id"
                v-model="form.type_id"
              >
                <option :value="0">{{ $t('main.type_not_selected') }}</option>
                <option
                  v-for="type in types"
                  :key="type.data.type_id"
                  :value="type.data.type_id"
                >
                  {{ type.data.attributes.name }}
                </option>
              </select>
            </div>
            <ValidationErrors :errors="errorsFor('type_id')" />
          </div>

          <div class="form-group">
            <label class="font-bold">{{ $t('main.label_status') }}: </label>
            <div>
              <button
                class="rounded flex items-center focus:outline-none gap-2"
                @click="form.status = form.status == 1 ? 0 : 1"
              >
                <span class="check"><i
                    v-if="form.status == 1"
                    class="fas fa-check text-red-500"
                  ></i></span>
                <span class="text-sm">{{$t('main.published')}}</span>
              </button>
            </div>
          </div>

          <div class="form-group bg-lightblue-border">
            <div class="flex items-center">
              <label
                for="image"
                class="font-bold"
              >{{ $t('admin.views.engraving.image_engraving') }}:
              </label>
              <div class="help ml-2 flex">
                <button class="bg-gray-400 flex justify-center items-center text-white w-4 h-4 rounded-full focus:outline-none">
                  ?
                </button>
              </div>
            </div>

            <FileInputBlock
              class="dark-bg"
              :prefill="imagePreview"
              :selectedImageFileNameDefault="$t('main.image_not_selected')"
              :alreadyLoadText="$t('main.image_selected')"
              :loadedFile="this.element&&this.element.data.attributes.image"
              @selected-file="(file) => selectFile(file, 'Image')"
              @remove-file="removeFile('Image')"
            >
              <ValidationErrors :errors="errorsFor('image')" />
            </FileInputBlock>

          </div>
        </div>
        <div class="w-2/3 ml-30 engraving__sizes">
          <div class="font-bold mb-2">{{ $t('main.sizes_cost') }} *:</div>

          <div class="form-group">

            <div class="engraving__type_cost_radio">
              <input
                type="radio"
                id="type_calc_cost_cub"
                :checked="form.type_calc_cost == 'cub'"
                v-model="form.type_calc_cost"
                value="cub"
              />
              <label
                for="type_calc_cost_cub"
                class="text-sm"
                v-html="$t('admin.views.elements.type_calc_cost_square')"
              ></label>
            </div>

            <div
              class="element-sizes-list"
              v-if="form.type_calc_cost == 'cub'"
            >
              <div class="font-bold mb-2">{{ $t('main.nominal_size') }}</div>
              <div
                class="flex element-sizes-list-line no-fotokeramika"
                v-for="(size, index) in fact_sizes"
                :key="`element-size-${index}`"
              >
                <div class="size-data flex flex-wrap">
                  <div class="cm flex items-end mr-30">
                    <div class="size-data-block height">
                      <label :for="`height-${index}`">{{ $t('main.height_sm') }}:</label>
                      <input
                        v-model="size.height"
                        type="number"
                        :id="`height-${index}`"
                        placeholder="0.00"
                      />
                    </div>
                    <div class="x mb-1 ml-1">X</div>
                    <div class="size-data-block width ml-1">
                      <label :for="`width-${index}`">{{ $t('main.width_sm') }}:</label>
                      <input
                        v-model="size.width"
                        type="number"
                        :id="`width-${index}`"
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                  <div class="size-data-block price mr-30">
                    <label
                      :for="`price-${index}`"
                      v-html="$t('main.cost_kv_sm')+', '+$t('main.currency')"
                    ></label>
                    <input
                      type="number"
                      :id="`price-${index}`"
                      placeholder="0.00"
                      v-model="size.price"
                    />
                  </div>
                  <div class="size-data-block price mr-30 cost-value">
                    <label
                      :for="`cost-${index}`"
                      v-html="$t('main.label_cost_price_currency_kvm')"
                    ></label>
                    <input
                      type="number"
                      :id="`cost-${index}`"
                      placeholder="0.00"
                      v-model="size.cost"
                    />
                  </div>
                </div>

              </div>
            </div>

            <ValidationErrors :errors="errorsFor('fact_sizes')" />
          </div>
          <div class="form-group">

            <div class="engraving__type_cost_radio">
              <input
                type="radio"
                id="type_calc_cost_fix"
                :checked="form.type_calc_cost == 'fix'"
                v-model="form.type_calc_cost"
                value="fix"
              />
              <label
                for="type_calc_cost_fix"
                class="text-sm"
              >{{$t('admin.views.elements.type_calc_cost_concrete_sizes')}}</label>
            </div>

            <div
              class="element-sizes-list"
              v-if="form.type_calc_cost == 'fix'"
            >
              <div
                class="flex mb-30 element-sizes-list-line"
                v-for="(size, index) in sizes"
                :key="`element-size-${index}`"
              >
                <div class="number-position mr-2 w-4">{{ index + 1 }}.</div>
                <div class="size-data flex flex-wrap">
                  <div class="cm flex items-end mr-30 mb-4">
                    <div class="size-data-block height">
                      <label :for="`height-${index}`">{{ $t('main.height_sm') }}:</label>
                      <input
                        v-model="sizes[index].height"
                        type="number"
                        :id="`height-${index}`"
                        placeholder="0.00"
                      />
                    </div>
                    <div class="x mb-1 ml-1">X</div>
                    <div class="size-data-block width ml-1">
                      <label :for="`width-${index}`">{{ $t('main.width_sm') }}:</label>
                      <input
                        v-model="sizes[index].width"
                        type="number"
                        :id="`width-${index}`"
                        placeholder="0.00"
                      />
                    </div>
                  </div>
                  <div class="price mr-30 mb-4 flex gap-4">
                    <div class="w-28">
                      <label :for="`price-${index}`">{{ $t('main.price') }}, {{ $t('main.currency') }}:</label>
                      <input
                        type="number"
                        :id="`price-${index}`"
                        placeholder="0.00"
                        v-model="sizes[index].price"
                      />
                    </div>
                    <div class="cost-value w-28">
                      <label :for="`price-${index}`">{{ $t('main.label_cost_price_currency') }}:</label>
                      <input
                        type="number"
                        :id="`cost-${index}`"
                        placeholder="0.00"
                        v-model="sizes[index].cost"
                      />
                    </div>

                  </div>
                </div>
                <div
                  class="size-remove pt-6"
                  v-if="index"
                >
                  <button
                    @click="removeSize(size.id)"
                    class="border-sky-blue px-2 rounded"
                    style="height: 30px"
                  >
                    <i class="fas fa-times fa-lg text-red-500"></i>
                  </button>
                </div>
              </div>

              <div class="mb-30 flex">
                <div class="w-6"></div>
                <div>
                  <button
                    class="btn btn-default btn-small"
                    @click="addSize"
                  >
                    {{ $t('main.button_add_block_sizes') }}
                  </button>
                </div>
              </div>
              <ValidationErrors :errors="errorsFor('sizes')" />

            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminStickyHeader from "../../../components/Admin/StickyHeader.vue";
import validationErrors from "../../../mixins/validationErrors";

import { v4 as uuidv4 } from "uuid";

const defaultImagePreview = "/images/design/zaglushka-gravirovka.svg";
export default {
  name: "Form",
  components: { AdminStickyHeader },
  mixins: [validationErrors],
  props: {
    element: {
      type: Object,
    },
    element_group: {
      type: Object,
    },
  },
  data() {
    return {
      sizes: [],
      fact_sizes: [],
      imagePreview: this.element
        ? this.element.data.attributes.image || defaultImagePreview
        : defaultImagePreview,
      loadingSaveData: false,
      form: {
        name: this.element ? this.element.data.attributes.name : "",
        article: this.element ? this.element.data.attributes.article : null,
        type_id: this.element ? this.element.data.attributes.type_id : null,
        type_calc_cost: this.element
          ? this.element.data.attributes.type_calc_cost
          : "fix",
        status: this.element
          ? parseInt(this.element.data.attributes.status)
          : 1,
        selectedImage: null,
      },
    };
  },
  created() {
    this.sizes = this.$store.state.elements.element_sizes;
    if (this.sizes.length == 0) {
      this.addSize();
    }
    this.fact_sizes =
      (this.element && this.element.data.attributes.fact_sizes) || [];
    if (this.fact_sizes.length == 0) {
      this.addFactSize();
    }
  },
  mounted() {
    if (!this.licensed) this.$router.push({ name: "no_license" });
  },
  computed: {
    types() {
      return this.$store.state.elements.types;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
  },
  methods: {
    async saveClose() {
      const element = await this.saveData();
      if (element) {
        this.$router.replace({
          name: "engravings",
          params: {
            slug: this.element_group.data.attributes.slug,
          },
          query: { ...this.$route.query },
        });
      }
    },
    async save() {
      const element = await this.saveData();
      if (element) {
        this.$router
          .replace({
            name: "edit_engraving",
            params: {
              slug: this.element_group.data.attributes.slug,
              element_id: element.element.data.element_id,
            },
            query: { ...this.$route.query },
          })
          .catch((error) => {});
      }
    },

    async saveCreate() {
      const newElement = await this.saveData();
      if (newElement) {
        if (this.$route.name == "add_engraving") {
          window.location.reload();
        } else {
          await this.$router
            .replace({
              name: "add_engraving",
              params: {
                slug: this.element_group.data.attributes.slug,
              },
              query: { ...this.$route.query },
            })
            .catch((error) => {});
        }
      }
    },

    async saveCopy() {
      const element = await this.saveData();
      if (element) {
        const clone = await this.$store.dispatch(
          "elements/copySingle",
          element.element.data.element_id
        );

        await this.$router.replace(
          {
            name: "edit_engraving",
            params: {
              slug: this.element_group.data.attributes.slug,
              element_id: clone.element.data.element_id,
              query: { ...this.$route.query },
            },
          },
          () => {
            location.reload();
          }
        );
      }
    },
    toggleFace(face) {
      if (this.form.faces.includes(face.id)) {
        this.form.faces = this.form.faces.filter((f) => f != face.id);
      } else {
        this.form.faces.push(face.id);
      }
    },
    selectFile(file, dataProps) {
      this.form[`selected${dataProps}`] = file;
      this.form[`remove${dataProps}`] = false;
    },
    removeFile(dataProps) {
      this.form[`selected${dataProps}`] = null;
      this.form[`remove${dataProps}`] = true;
    },
    addSize() {
      this.sizes.push({
        id: uuidv4(),
        height: null,
        width: null,
        price: null,
        cost: null,
      });
    },
    removeSize(id) {
      this.sizes = this.sizes.filter((size) => size.id != id);
    },
    addFactSize() {
      this.fact_sizes.push({
        id: uuidv4(),
        height: null,
        depth: null,
        length: null,
        width: null,
        price: null,
        cost: null,
      });
    },
    async saveData() {
      this.errors = null;
      this.loadingSaveData = true;
      try {
        let formDataPost = new FormData();

        if (this.element) formDataPost.append("_method", "PATCH");

        formDataPost.append("name", this.form.name);
        formDataPost.append("article", this.form.article);
        formDataPost.append("type_id", this.form.type_id);
        formDataPost.append("status", parseInt(this.form.status));
        formDataPost.append("type_calc_cost", this.form.type_calc_cost);

        if (this.form.selectedImage !== null) {
          formDataPost.append("image", this.form.selectedImage);
        }

        if (this.form.removeImage) {
          formDataPost.append("remove_image", this.form.removeImage);
        }

        if (this.sizes.length > 0) {
          this.sizes.forEach((size, index) => {
            formDataPost.append(`sizes[${index}][id]`, size.id);
            formDataPost.append(`sizes[${index}][height]`, size.height);
            formDataPost.append(`sizes[${index}][width]`, size.width);
            formDataPost.append(`sizes[${index}][price]`, size.price);
            formDataPost.append(`sizes[${index}][cost]`, size.cost);
          });
        }
        if (this.fact_sizes.length > 0) {
          this.fact_sizes.forEach((size, index) => {
            formDataPost.append(`fact_sizes[${index}][id]`, size.id);
            if (size.height) {
              formDataPost.append(`fact_sizes[${index}][height]`, size.height);
            }
            if (size.depth) {
              formDataPost.append(`fact_sizes[${index}][depth]`, size.depth);
            }
            if (size.length) {
              formDataPost.append(`fact_sizes[${index}][length]`, size.length);
            }
            if (size.width) {
              formDataPost.append(`fact_sizes[${index}][width]`, size.width);
            }
            formDataPost.append(`fact_sizes[${index}][price]`, size.price);
            formDataPost.append(`fact_sizes[${index}][cost]`, size.cost);
          });
        }

        let url = `/api/admin/elements/${this.element_group.data.attributes.slug}`;
        if (this.element)
          url = `/api/admin/elements/${this.element_group.data.attributes.slug}/${this.element.data.element_id}`;

        const res = (
          await axios.post(url, formDataPost, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        ).data;

        return res.data;
      } catch (error) {
        this.errors = error.response && error.response.data.errors;
        this.status = error.response && error.response.status;
        if (error.response) {
          const notification = {
            type: "error",
            message:
              error.response &&
              error.response.data &&
              error.response.data.message,
          };
          this.$store.dispatch("notification/add", notification, {
            root: true,
          });
        }
      } finally {
        this.loadingSaveData = false;
      }
    },
  },
};
</script>
<style scoped>
.element-sizes-list-line.no-fotokeramika .size-data {
  border-bottom: none;
}
.element-sizes-list-line.no-fotokeramika .size-data-block.price {
  width: auto;
}
.element-sizes-list-line.no-fotokeramika .size-data-block.price input {
  width: 90px;
}
.engraving__sizes .form-group + .form-group {
  margin-top: 7px;
}
.engraving__type_cost_radio {
  display: flex;
  column-gap: 7px;
  align-items: center;
}
.engraving__type_cost_radio label {
  margin-bottom: 0;
}
.engraving__type_cost_radio + .element-sizes-list {
  margin-top: 10px;
  margin-left: 25px;
  margin-bottom: 20px;
}
</style>
